import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { SimListService } from './sim-list.service';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';

@Component({
  selector: 'app-sim-list',
  templateUrl: './sim-list.component.html',
  styleUrl: './sim-list.component.css'
})
export class SimListComponent implements OnInit, OnDestroy {

  onUpdateEvent = new EventEmitter<ActionButtonEvent>();

  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[] = [
    {
      icon: 'cached'
      , tooltip: 'Update',
      eventEmitter: this.onUpdateEvent
    }
  ];



  columnSettings: ColumnSetting[] = [

    {
      columnId: 'deviceID',
      name: 'Device ID'
    },
    {
      columnId: 'status',
      name: 'Status'
    },
    {
      columnId: 'dateSessionStartedAgo',
      name: 'Session started'
    },
    {
      columnId: 'dateSessionEndedAgo',
      name: 'Session ended'
    },
    {
      columnId: 'iccid',
      name: 'ICCID'
    }
  ]

  simList$;

  simList = [];

  constructor(public simListService: SimListService) {


  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    
    console.log(this.simListService)

    this.simList$ = this.simListService.getList$();

    this.onUpdateEvent.subscribe((event) => this.onUpdate(event))
  }

  onUpdate(event) {

    const iccid = event.eventData ? event.eventData.iccid : null;
    
    if(iccid) {
      this.simListService.updateSimInfo(iccid);
    }

    return null;
  }

  openAddSimDialog(){
    console.log("hello")
    console.log(this.simListService);
  }

}
